import React from "react";
import { Navigation } from "./components/navigation";


import SmoothScroll from "smooth-scroll";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import "./App.css";
import Home from "./pages/Home";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import PortfolioPage from "./pages/PortfolioPage";
import ContactUsPage from "./pages/ContactUsPage";
import { Box } from "@mui/material";
import { Supply } from "./components/supply";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  

  return (
    <Router>
      <div>
        <Navigation />
        <Box sx={{mt:10}}>
        <Routes>
          <Route path="/" element={<Home  />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/portfolio" element={<PortfolioPage  />} />
          {/* <Route path="/testimonials" element={<Testimonials />} /> */}
          <Route path="/contact-us" element={<ContactUsPage />} />
          <Route path="/supply" element={<Supply/>} />
        </Routes>
        </Box>
      </div>
    </Router>
  );
};

export default App;
